import React from 'react';
import { Play, Check } from 'lucide-react';
import { cn } from '@/lib/utils';

interface DarkMembersEpisodeCardProps {
  index: number;
  title: string;
  duration?: string;
  thumbnail?: string;
  isPlaying: boolean;
  isWatched: boolean;
  progress?: number;
  onClick: () => void;
}

export function DarkMembersEpisodeCard({
  title,
  duration,
  thumbnail,
  isPlaying,
  isWatched,
  progress,
  onClick,
}: DarkMembersEpisodeCardProps) {
  return (
    <button
      onClick={onClick}
      className={cn(
        'w-full text-left flex items-center gap-3.5 py-3.5 px-4 rounded-lg',
        'transition-all duration-[250ms] ease-out group',
        isPlaying
          ? 'bg-white border-l-4 border-l-[#0057FF]'
          : 'bg-transparent border-l-4 border-l-transparent hover:bg-[rgba(255,255,255,0.05)]'
      )}
    >
      {/* Thumbnail com Overlay nas Inativas */}
      <div className="w-[110px] h-[65px] rounded-lg overflow-hidden flex-shrink-0 relative">
        {thumbnail ? (
          <img 
            src={thumbnail} 
            alt={title}
            className={cn(
              "w-full h-full object-cover transition-all duration-[250ms]",
              !isPlaying && "brightness-75 group-hover:brightness-100"
            )}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-[#0B1423]">
            <Play className="w-6 h-6 text-white/40" />
          </div>
        )}
        
        {/* Barra de Progresso */}
        {progress !== undefined && progress > 0 && (
          <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-black/20">
            <div 
              className="h-full bg-[#3B82F6] transition-all duration-300"
              style={{ width: `${Math.min(progress, 100)}%` }}
            />
          </div>
        )}
        
        {/* Badge Concluído */}
        {isWatched && (
          <div className="absolute top-1 right-1 w-4 h-4 rounded-full bg-green-500 flex items-center justify-center">
            <Check className="w-2.5 h-2.5 text-white" />
          </div>
        )}
      </div>

      {/* Info */}
      <div className="flex-1 min-w-0">
        {/* Título */}
        <h4 
          className={cn(
            "text-[15px] font-medium line-clamp-2 mb-1 transition-colors duration-[250ms]",
            isPlaying 
              ? "text-black"
              : "text-[#A5A5A5] group-hover:text-white"
          )}
        >
          {title}
        </h4>
        
        {/* Duração */}
        {duration && (
          <span 
            className={cn(
              "text-[13px] font-normal transition-colors duration-[250ms]",
              isPlaying 
                ? "text-black/70"
                : "text-[#7B7B7B]"
            )}
          >
            {duration}
          </span>
        )}
      </div>
    </button>
  );
}
